import NDFL3YearLogic2017 from './NDFL3YearLogic2017';
import { get, includes } from 'lodash';
import { numberFieldRestrict13_2Fn, numberFieldRestrict13Fn } from '../CommonValidations';

class NDFL3YearLogic2018 extends NDFL3YearLogic2017 {
  name() {
    return '2018';
  }

  showRemainsFields() {
    return false;
  }

  isComplexDwellingRegDateName() {
    return true;
  }

  showObjectIf(applicantCategory) {
    return applicantCategory !== '12';
  }

  /**
   * «Супруг собственника объекта,
   * заявляющий имущественный налоговый вычет в порядке,
   * предусмотренном пунктом 10 статьи 220 Кодекса»
   * @returns {boolean}
   */
  disablePersonalDataFields() {
    return true;
  }

  getIncomeFieldsFormat() {
    return numberFieldRestrict13_2Fn;
  }

  getTaxSumFieldsFormat() {
    return numberFieldRestrict13Fn;
  }

  getNDFL3BreadCrumbsMapping() {
    return {
      initialData: {
        title: 'Титульный лист',
        order: 1,
      },
      inRF: {
        title: 'Приложение 1',
        order: 2,
      },
      outRF: {
        title: 'Приложение 2',
        order: 3,
      },
      investmentDeduction: {
        title: 'Приложение 5',
        order: 4,
      },
      socialDeduction: {
        title: 'Приложение 5',
        order: 5,
      },
      standardDeduction: {
        title: 'Приложение 5',
        order: 6,
      },
      propertyDeduction: {
        title: 'Приложение 7',
        order: 7,
      },
      lossesTransferDeduction: {
        title: 'Приложение 8',
        order: 8,
      },
    };
  }

  getInvestmentBreadcrumbBinding() {
    return 'socialDeduction';
  }

  /**
   * Сокрытие 3-его сценария:
   * На вкладке "Выбор доходов" задизейблить возможность выбора "Доходы от источников за пределами РФ"
   * @returns {boolean}
   */
  hideNotReleasedFunctionality() {
    return false;
  }

  /**
   * Сокрытие 6-го сценария:

   На вкладке "Доходы в РФ" (если вкладка "Доходы вне РФ открыта - то и на ней тоже) в секции "Сведения о доходе" скрывать поле "предоставить налоговый вычет для доходов с кодами 2762, 2720, 2730, 2760, 2770, 2740, 2761, 3011, 2790, 1211, 2799. (доходы 3011 и 2799 - новые, специфичные для 2018 года)
   * @returns {boolean}
   */
  showTaxDeduction() {
    return true;
  }

  showTaxForeignIncomeSum(incomeType) {
    return incomeType === 1000;
  }

  /**
   * удалить доля расходов, расходы управляющих товарищей, убыток прошлых лет и сумма вкладов
   * @returns {boolean}
   */
  hide2018Fields() {
    return true;
  }

  showApplyDeduction(incomeTypeCode) {
    const allowedIncomeTypes = [
      1544,
      1549,
      1545,
      1546,
      1548,
      1547,
      1551,
      9551,
      1552,
      9552,
      9981,
      9982,
      9983,
      9984,
      9986,
      9985,
    ];
    return allowedIncomeTypes.includes(incomeTypeCode);
  }

  disableDeductionSum(incomeTypeCode) {
    const allowedIncomeTypes = [3011, 2799, 3010];
    return allowedIncomeTypes.includes(incomeTypeCode);
  }

  displayAddMoreDeductions(incomeCode) {
    const incomeCodesForMultipleDeductions = [1530, 1531, 1544, 1545];
    return incomeCodesForMultipleDeductions.includes(incomeCode);
  }

  showLosses2018() {
    return true;
  }

  hideDeductionCodeByIncome(incomeCode, deductionCode) {
    const exceptions = {
      1530: [618],
      1531: [217, 223],
      1535: [210],
      1536: [205, 209],
      1544: [237, 239, 251, 619],
      1549: [236],
      1545: [238, 240],
      1546: [250, 252],
      1548: [241],
    };

    return includes(get(exceptions, incomeCode, []), deductionCode);
  }

  incomeCodesCanBeMoreThanIncomeSum(incomeCode) {
    const permittedListIncome = [
      1544,
      1545,
      1546,
      1547,
      1548,
      1549,
      1551,
      9551,
      1552,
      9552,
      1530,
      1536,
      1531,
      1532,
      1533,
      1535,
      1537,
      9537,
      1538,
      9538,
      9991,
      9981,
      9992,
      9982,
      9993,
      9983,
      9994,
      9984,
      9995,
      9985,
      9996,
      9986,
      1541,
      1539,
      1553,
      1554,
    ];

    return includes(permittedListIncome, incomeCode);
  }

  showDrugsExpenses() {
    return false;
  }
}

export default NDFL3YearLogic2018;
